import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import useDeviceDetect from '../../helpers/hooks';

const LS_INFO_NAME = 'MenuWarningWindowClosed_v1'

export default function MenuWarningInfo() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if(!localStorage.getItem(LS_INFO_NAME)) setVisible(true);
  }, [])

  const onClose = () => {
    localStorage.setItem(LS_INFO_NAME, '1');
    setVisible(false)
  }

  const { isMobile } = useDeviceDetect();
  
  if(!isMobile) {
    return <AttentionBlock>
      Отпуск рецептурных лекарственных препаратов осуществляется по рецепту врача!
      <br />
      <span>
        При бронировании через сайт действует скидка до 10%
      </span>
    </AttentionBlock>
  }

  return visible && <FixedBlock>
    <TwoColumns>
      <div>
        Отпуск рецептурных лекарственных препаратов осуществляется по рецепту врача!
      </div>
      <CloseButton onClick={onClose}>&#10006;</CloseButton>
    </TwoColumns>
    При бронировании через сайт действует скидка до 10%
  </FixedBlock>;

}

const AttentionBlock = styled.div`
  color: #9c8450;
  border: 1px solid #9c8450;
  padding: 20px;
  text-align: center;
  font-size: var(--text-uppercase-menu-big);
  border-radius: 5px;
  opacity: 0.9;
  margin: 0 20px;

  & span {
    color: var(--red);
  }

  @media (max-width: 750px) {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    font-size: 14px;
    padding: 10px 20px;
    border-radius: 0;
    margin: 0 0 5px;
  }
`

const FixedBlock = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 1rem;
  background: #fff;
  width: 100%;
  z-index: 100;
  box-shadow: 0 0 8px 0 rgba(34, 60, 80, 0.5);
  line-height: 1.5;
  color: var(--red);
`

const TwoColumns = styled.div`
  display: flex;
  margin-bottom: 5px;
  color: #9c8450;
  gap: 5px;
`

const CloseButton = styled.div`
  padding: 8px;
  line-height: 1;
  font-size: 24px;
  color: var(--color-text);
`